
<template>
  <div id="ecommerce-checkout-demo">
    <form-wizard
      ref="checkoutWizard"
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      :hide-buttons="true"
    >
      <tab-content :title="$store.state.getLabel($store.state.language).cart" icon="feather icon-shopping-cart" class="mb-5">
        <div class="vx-row" v-if="cartItems.length">
          <div class="vx-col lg:w-2/3 w-full relative">
            <div
              class="items-list-view"
              v-for="(item, index) in cartItems"
              :key="item.objectID + index"
            >
              <item-list-view :item="item" class="mb-base">
                <template slot="item-meta">
                  <div class="vx-col">
                    <h6
                      class="item-name font-semibold mb-1 cursor-pointer hover:text-primary"
                    >{{ item.name_chi }}</h6>
                    <h6
                      class="item-name font-semibold mb-1 cursor-pointer hover:text-primary"
                    >{{ item.name_eng }}</h6>
                    <h6
                      class="item-name font-semibold mb-1 cursor-pointer hover:text-primary"
                    >{{ item.name_english }}</h6>
                    <h6
                      class="item-name font-semibold mb-1 cursor-pointer hover:text-primary"
                    >({{item.categories[0]}})</h6>
                    <p class="text-sm mb-2">
                      By
                      <span class="font-semibold cursor-pointer">{{ item.brand_chi }}</span>
                      <span class="font-semibold cursor-pointer"> {{ item.brand_eng }}</span>
                    </p>
                    <div class="item-description text-sm " v-if="item.orderOption">
                      {{$store.state.getLabel($store.state.language).with}}
                      <span v-for="(list, index) in item.orderOption" :key="index">
                        <span>{{list.name}}</span>
                        <span v-if="index+1 < item.orderOption.length">+</span>
                      </span>
                    </div>
                    <p
                      class="text-primary font-semibold text-xl mt-3"
                    >${{ item.unit_price + calculatePerItem(item)}} / {{$store.state.getLabel($store.state.language).set}}</p>
                  </div>
                  <div class="vx-col">
                    <p class="mt-4 font-bold text-sm">{{$store.state.getLabel($store.state.language).qty}}</p>
                    <vs-input-number
                      min="1"
                      max="10"
                      :value="item.quantity"
                      @input="updateItemQuantity($event, index)"
                      class="inline-flex"
                    />
                  </div>
                </template>

                <template slot="action-buttons">
                  <div
                    class="item-view-primary-action-btn p-3 rounded-lg flex flex-grow items-center justify-center cursor-pointer mb-3"
                    @click="removeItemFromCart(item)"
                  >
                    <feather-icon icon="XIcon" svgClasses="h-4 w-4" />
                    <span class="text-sm font-semibold ml-2">{{$store.state.getLabel($store.state.language).del}}</span>
                  </div>
                </template>
              </item-list-view>
            </div>
          </div>

          <div class="vx-col lg:w-1/3 w-full">
            <vx-card>
              <p class="font-semibold mb-3">{{$store.state.getLabel($store.state.language).orderDetails}}</p>

              <vs-divider />

              <div class="flex justify-between mb-2">
                <span>{{this.orderDetail.qty}} {{$store.state.getLabel($store.state.language).qtyOrder}}</span>
              </div>
              <div class="flex justify-between mb-2" 
                v-for="(item, index) in cartItems"
                :key="item.objectID + index">
                <span>
                  - {{item.name_chi?item.name_chi:''}} <br/> &nbsp;  {{item.name_eng?item.name_eng: ''}} &nbsp;  {{item.name_english?item.name_english: ''}}
                  <span
                    class="item-description text-sm"
                    v-if="item.orderOption"
                  >
                  <span v-for="(list, index) in item.orderOption" :key="index">
                        <span>{{list.name}}</span>
                        <span v-if="index+1 < item.orderOption.length">+</span>
                  </span>
                  
                  
                    <br />
                  </span>
                  x {{item.quantity}}
                  ({{item.categories[0]}})
                </span>

                <span>${{(item.unit_price + calculatePerItem(item)) * item.quantity}}</span>
              </div>
              <!-- <div class="flex justify-between mb-2">
                <span>- {{$store.state.getLabel($store.state.language).shipping}}</span>
                <span>${{this.orderDetail.shipping}}</span>
              </div> -->
              <p class="text-primary mt-2 text-sm" v-if="this.orderDetail.addition > 0"> {{$store.state.getLabel($store.state.language).minCharge}}: $60</p>
              <div class="flex justify-between mb-2" v-if="this.orderDetail.addition > 0">
                <span>- {{$store.state.getLabel($store.state.language).minChargePayment}}</span>
                <span>${{this.orderDetail.addition}}</span>
              </div>
              <p class="text-success mt-2">{{$store.state.getLabel($store.state.language).estimate}}</p>

              <vs-divider />
              <div class="flex justify-between font-semibold mb-3" style="color:red">{{$store.state.getLabel($store.state.language).deliveryFee}}</div>
              <div class="flex justify-between font-semibold mb-3">
                
                <span>{{$store.state.getLabel($store.state.language).total}}</span>
                <span class="text-primary">${{orderDetail.ttlPrice}}</span>
              </div>

              <vs-button class="w-full mt-5" @click="isExcessOrderLimit();">{{$store.state.getLabel($store.state.language).next}}</vs-button>
            </vx-card>
          </div>
        </div>

        <vx-card :title="$store.state.getLabel($store.state.language).noFood" v-else>
          <vs-button @click="$router.push('/meal').catch(() => {})">{{$store.state.getLabel($store.state.language).findFood}}</vs-button>
        </vx-card>
      </tab-content>

      <tab-content :title="$store.state.getLabel($store.state.language).orderAddress" icon="feather icon-home" class="mb-5">
        <div class="vx-row">
          <div class="vx-col lg:w-2/3 w-full">
            <vx-card :title="$store.state.getLabel($store.state.language).writeAddress" :subtitle="$store.state.getLabel($store.state.language).toAddressMsg" class="mb-base">
              <form data-vv-scope="add-new-address">
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      v-validate="{ required: true, regex: /^[ -'a-z\u4e00-\u9eff]{1,20}$/i }"
                      data-vv-as="field"
                      name="fullName"
                      :label="$store.state.getLabel($store.state.language).custName"
                      v-model="orderInfo.fullName"
                      class="w-full mt-5"
                    />
                    <span
                      v-show="errors.has('add-new-address.fullName')"
                      class="text-danger"
                    >{{ $store.state.getLabel($store.state.language).fillNameMsg }}</span>
                  </div>

                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      v-validate="'required|digits:8'"
                      name="mobileNum"
                      :label="$store.state.getLabel($store.state.language).phone+':'"
                      v-model="orderInfo.mobileNum"
                      class="w-full mt-5"
                    />
                    <span
                      v-show="errors.has('add-new-address.mobileNum')"
                      class="text-danger"
                    >{{ $store.state.getLabel($store.state.language).fillPhoneMsg }}</span>
                  </div>
                </div>

                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      v-validate="'required'"
                      name="address1"
                      :label="$store.state.getLabel($store.state.language).address1"
                      v-model="orderInfo.address1"
                      class="w-full mt-5"
                    />
                    <span
                      v-show="errors.has('add-new-address.address1')"
                      class="text-danger"
                    >{{ $store.state.getLabel($store.state.language).fillAddressMsg }}</span>
                  </div>

                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-input
                      name="address2"
                      :label="$store.state.getLabel($store.state.language).address2"
                      v-model="orderInfo.address2"
                      class="w-full mt-5"
                    />
                  </div>
                </div>

                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">
                    <vs-select :label="$store.state.getLabel($store.state.language).dist" v-model="orderInfo.district" class="w-full mt-5">
                      <vs-select-item
                        :key="index"
                        :value="item.value"
                        :text="item.text"
                        v-for="(item,index) in districtOptions"
                      />
                    </vs-select>
                    <span
                      v-show="errors.has('add-new-address.district')"
                      class="text-danger"
                    >{{ $store.state.getLabel($store.state.language).selectDist }}</span>
                  </div>

                </div>

                <vs-button
                  class="mt-6 ml-auto flex"
                  @click="submitNewAddressForm();scrollToTop();"
                >{{$store.state.getLabel($store.state.language).saveNext}}</vs-button>
              </form>
            </vx-card>
          </div>

          <div class="vx-col lg:w-1/3 w-full">
            <vx-card :title="orderInfo.fullName">
              <div>
                <p>{{$store.state.getLabel($store.state.language).address1}} {{orderInfo.address1}}</p>
                <p>{{$store.state.getLabel($store.state.language).address2}} {{orderInfo.address2}}</p>
                <p class="my-4">{{$store.state.getLabel($store.state.language).saiKung}} </p>
                <p>{{$store.state.getLabel($store.state.language).phoneNum}} {{orderInfo.mobileNum}}</p>
              </div>

              <vs-divider />

            </vx-card>
          </div>
        </div>
      </tab-content>

      <tab-content :title="$store.state.getLabel($store.state.language).pay" icon="feather icon-credit-card" class="mb-5">
        <div class="vx-row">
          <div class="vx-col lg:w-2/3 w-full">
            <vx-card :title="$store.state.getLabel($store.state.language).paymentMethod" :subtitle="$store.state.getLabel($store.state.language).paymeMsg" class="mb-base">
              <div class="mt-3">
                <ul>
                  <li>
                    <div class="flex flex-wrap justify-between items-center">
                      <vs-radio v-model="orderInfo.paymentMethod" vs-value="Payme">
                        <div class="flex items-center">
                          <img
                            src="@/assets/images/logo/payme.png"
                            alt="bank-logo"
                            height="80"
                            width="160"
                            class="inline-flex"
                          />
                        </div>
                      </vs-radio>
                    </div>
                    <div class="flex flex-wrap justify-between items-center">
                      <vs-radio v-model="orderInfo.paymentMethod" vs-value="FPS">
                        <div class="flex items-center">
                          <img
                            src="@/assets/images/logo/fps.png"
                            alt="bank-logo"
                            height="80"
                            width="80"
                            class="inline-flex"
                          />
                        </div>
                      </vs-radio>
                    </div>
                    <div class="flex flex-wrap justify-between items-center">
                      <vs-radio v-model="orderInfo.paymentMethod" vs-value="Cash">
                        <div class="flex items-center">
                          <img
                            src="@/assets/images/logo/cash.png"
                            alt="bank-logo"
                            height="80"
                            width="80"
                            class="inline-flex"
                          />
                        </div>
                      </vs-radio>
                    </div>
                    
                    <form data-vv-scope="cvv-form">
                      <div class="flex items-center flex-wrap">
                        <span class="mt-4">{{$store.state.getLabel($store.state.language).toDelivererMsg}}</span>
                        <vs-textarea name="remarks" v-model="orderInfo.remarks" class="mr-3 mt-4" />
                      </div>
                      <vs-button
                        class="mt-4"
                        @click.prevent="confirmOrderPrompt = true"
                        :disabled="false"
                      >{{$store.state.getLabel($store.state.language).confirmOrder}}</vs-button>
                    </form>
                  </li>
                </ul>
                <vs-prompt
                  @cancel="confirmOrderPrompt = false"
                  @accept="makePayment"
                  @close="confirmOrderPrompt = false"
                  :accept-text="$store.state.getLabel($store.state.language).accept"
                  :cancel-text="$store.state.getLabel($store.state.language).back"
                  :title="$store.state.getLabel($store.state.language).confirmOrderTitle"
                  :active.sync="confirmOrderPrompt"
                  
                >
                  <div class="vx-col w-full h-full">
                    <vx-card>
                      <div class="flex justify-between mb-2">
                        <span>{{this.orderDetail.qty}} {{$store.state.getLabel($store.state.language).qtyOrder}}</span>
                      </div>
                      <div
                        class="flex justify-between mb-2"
                        v-for="(item, index) in cartItems"
                        :key="item.objectID + index"
                      >
                        <span >
                          - {{item.name_chi?item.name_chi:''}} {{item.name_eng?item.name_eng: ''}}
                          x {{item.quantity}}
                          ({{item.categories[0]}})
                          <div
                            class="item-description text-sm "
                            v-if="item.orderOption"
                          >
                            <div v-for="(list, index) in item.orderOption" :key="index">
                             + {{list.name}}(${{list.price}})
                            </div>
                          </div>
                        </span>
                        <span>${{(item.unit_price + calculatePerItem(item)) * item.quantity}} </span>
                      </div>
                      <!-- <div class="flex justify-between mb-2">
                        <span>- {{$store.state.getLabel($store.state.language).shipping}}</span>
                        <span>${{this.orderDetail.shipping}}</span>
                      </div> -->

                      <div class="flex justify-between mb-2" v-if="this.orderDetail.addition>0">
                        <span>- {{$store.state.getLabel($store.state.language).minChargePayment}}</span>
                        <span>${{this.orderDetail.addition}}</span>
                      </div>
                      <div class="mt-3">
                        <h6>{{$store.state.getLabel($store.state.language).deliverDetail}}</h6>
                        <p class="mt-1">{{orderInfo.fullName}}</p>
                        <p class="mt-1">{{$store.state.getLabel($store.state.language).address1}}{{orderInfo.address1}}</p>
                        <p class="mt-1" v-if="orderInfo.address2">{{$store.state.getLabel($store.state.language).address2}} {{orderInfo.address2}}</p>
                        <p class="mt-1">{{$store.state.getLabel($store.state.language).phoneNum}} {{orderInfo.mobileNum}}</p>
                      </div>
                      
                      <div class="flex justify-between mt-3">
                        <span>{{$store.state.getLabel($store.state.language).totalLabel}}</span>
                        <span class="font-semibold text-lg">${{this.orderDetail.ttlPrice}}</span>
                      </div>
                    </vx-card>
                  </div>
                </vs-prompt>
              </div>
            </vx-card>
          </div>

          <!-- RIGHT COL: PRICE -->
          <div class="vx-col lg:w-1/3 w-full">
            <vx-card :title="$store.state.getLabel($store.state.language).orderDetails">
              <div class="flex justify-between mb-2">
                <span>{{this.orderDetail.qty}} {{$store.state.getLabel($store.state.language).qtyOrder}}</span>
              </div>
              <div
                class="flex justify-between mb-2"
                v-for="(item, index) in cartItems"
                :key="item.objectID + index"
              >
                <span>
                  - {{item.name_chi?item.name_chi:''}} <br/> &nbsp;  {{item.name_eng?item.name_eng: ''}} &nbsp;  {{item.name_english?item.name_english: ''}}
                  <span
                    class="item-description text-sm"
                    v-if="item.orderOption"
                  >
                  <span v-for="(list, index) in item.orderOption" :key="index">
                        <span>{{list.name}}</span>
                        <span v-if="index+1 < item.orderOption.length">+</span>
                  </span>
                  
                  
                    <br />
                  </span>
                  x {{item.quantity}}
                  ({{item.categories[0]}})
                </span>
                <span>${{(item.unit_price + calculatePerItem(item)) * item.quantity}}</span>
              </div>
              <!-- <div class="flex justify-between mb-2">
                <span>- {{$store.state.getLabel($store.state.language).shipping}}</span>
                <span>${{this.orderDetail.shipping}}</span>
              </div> -->
              <div class="flex justify-between mb-2">
                <span>- {{$store.state.getLabel($store.state.language).minChargePayment}}</span>
                <span>${{this.orderDetail.addition}}</span>
              </div>

              <vs-divider />

              <div>
                <h4>{{$store.state.getLabel($store.state.language).deliverDetail}}</h4>
                <p class="my-4">{{orderInfo.fullName}}</p>
                <p>{{$store.state.getLabel($store.state.language).address1}} {{orderInfo.address1}}</p>
                <p>{{$store.state.getLabel($store.state.language).address2}} {{orderInfo.address2}}</p>
                <p class="my-4">{{$store.state.getLabel($store.state.language).saiKung}}</p>
                <p>{{$store.state.getLabel($store.state.language).phoneNum}} {{orderInfo.mobileNum}}</p>
              </div>

              <vs-divider />
              <div class="flex justify-between font-semibold mb-3" style="color:red">{{$store.state.getLabel($store.state.language).deliveryFee}}</div>
              <div class="flex justify-between">
                <span>{{$store.state.getLabel($store.state.language).totalLabel}}</span>
                <span class="font-semibold text-lg">${{this.orderDetail.ttlPrice}}</span>
              </div>
            </vx-card>
          </div>
        </div>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
const ItemListView = () => import("../components/ItemListView.vue");
import BackToTop from "vue-backtotop";

export default {
  data() {
    return {
      // TAB 2
      orderInfo: {
        fullName: "",
        mobileNum: "",
        address1: "",
        address2: "",
        district: 99,
        addressType: "",
        remarks: "",
        paymentMethod: "",
        Whatsapp: "",
        orderDetail: {}
      },
      confirmOrderPrompt: false,
      addressTypeOptions: [
        { text: "住宅", value: 1 }
      ],
      districtOptions: [{ text: this.$store.state.getLabel(this.$store.state.language).saiKung, value: 99 }],
      formVerified: false,
      // TAB 3
      paymentMethod: "payme",
      Whatsapp: "",
      orderDetail: {
        price: 999,
        discount: -99,
        shipping: 0
      }
    };
  },
  computed: {
    cartItems() {
      return this.$store.state.cartItems.slice().reverse();
    },
    isInWishList() {
      return itemId => this.$store.getters["isInWishList"](itemId);
    }
  },
  created() {
    this.calculatePrice();
  },
  mounted: function() {
    var mealList = this.$store.state.cartItems;
    var restList = this.$store.state.selectedRestaurant;

    if (restList.length == 0) this.$router.push("/").catch(() => {});
    if (mealList.length == 0) this.$router.push("/meal").catch(() => {});
  },
  methods: {
    isExcessOrderLimit() {
      var ttlQty = 0;
      const limit = 30;

      this.$store.state.cartItems.forEach(e => {
        ttlQty += e.quantity;
      });
      if (limit - ttlQty < 0) {
        this.$vs.notify({
          title: this.$store.state.getLabel(this.$store.state.language).tips,
          text: this.$store.state.getLabel(this.$store.state.language).limitMsg,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
        return true;
      }
      this.$refs.checkoutWizard.nextTab();
      this.scrollToTop();
      return false;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    // TAB 1
    goToPrevious() {
      this.$router.push("/meal").catch(() => {});
    },
    removeItemFromCart(item) {
      this.$store.dispatch("toggleItemInCart", item);
      this.calculatePrice();
    },
    wishListButtonClicked(item) {
      // Toggle in Wish List
      if (this.isInWishList(item.objectID))
        this.$router.push("/wish-list").catch(() => {});
      else {
        this.toggleItemInWishList(item);
        this.removeItemFromCart(item);
      }
    },
    toggleItemInWishList(item) {
      this.$store.dispatch("toggleItemInWishList", item);
    },
    updateItemQuantity(event, index) {
      const itemIndex = Math.abs(index + 1 - this.cartItems.length);

      this.$store.dispatch("updateItemQuantity", {
        quantity: event,
        index: itemIndex
      });
      this.calculatePrice();
    },
    calculatePerItem(item) {
      var price = 0;
      if(item.orderOption)
        item.orderOption.forEach(opt => {
          price += opt.price;
        });
      return price;
    },
    calculatePrice() {
      const items = this.$store.state.cartItems;
      const restList = this.$store.state.selectedRestaurant;
      var price = 0;
      var ttlPrice = 0;
      var shipping = 0;
      var addition = 0;
      var qty = 0;
      var minCharge = 60;
      var shippingListResList = [];
      items.forEach(element => {
        if (shippingListResList.findIndex(i => i == element.rId) == -1) {
          var index = restList[restList.findIndex(i => i.rId == element.rId)];
          shipping = shipping + index.fee;
          shippingListResList.push(index.rId);
        }
        var extra = this.calculatePerItem(element);
        price += (element.unit_price + extra) * element.quantity;

        qty = qty + element.quantity;
      });

      ttlPrice = price;
      if (price < minCharge) {
        addition = minCharge - price;
        ttlPrice = ttlPrice + addition;
      }

      if(qty > 10 ){
        var shipping = shipping *2
      }else if(qty > 20){
        var shipping = shipping *3
      }else if(qty > 30){
        var shipping = shipping *4
      }

      
      this.orderDetail = {
        price: price,
        qty: qty,
        addition: addition,
        ttlPrice: ttlPrice,
        discount: "/",
        shipping: shipping,
        resTtl: shippingListResList.length,
        orderContact: restList[0].whatsapp?restList[0].whatsapp:'',
        items: items
      };
      this.orderInfo.orderDetail = this.orderDetail;
    },
    // TAB 2
    submitNewAddressForm() {
      return new Promise(() => {
        this.$validator.validateAll("add-new-address").then(result => {
          if (result) {
            // if form have no errors
            this.formVerified = true;
            this.$refs.checkoutWizard.nextTab();
          } else {
            this.$vs.notify({
              title: this.$store.state.getLabel(this.$store.state.language).tips,
              text: this.$store.state.getLabel(this.$store.state.language).verifyInfo,
              color: "warning",
              iconPack: "feather",
              icon: "icon-alert-circle"
            });
          }
        });
      });
    },
    // TAB 3
    makePayment() {
      return this.$store
        .dispatch("createNewOrder", this.orderInfo)
        .then(success => {
          if (success) {
            this.$router.push("/successPayment").catch(() => {});
          }
        });
    }
  },
  components: {
    ItemListView,
    FormWizard,
    TabContent,
    BackToTop
  }
};
</script>

<style lang="scss" scoped>
#ecommerce-checkout-demo {
  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
  }

  .item-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 2;
  }

  .vue-form-wizard {
    padding-bottom: 0;

    ::v-deep .wizard-header {
      padding: 0;
    }

    ::v-deep .wizard-tab-content {
      padding-right: 0;
      padding-left: 0;
      padding-bottom: 0;

      .wizard-tab-container {
        margin-bottom: 0 !important;
      }
    }
  }
}
</style>
